import axios from 'axios';
import api from './api';

/**
 * Servicio de suscripción al newsletter.
 *
 * La suscripción entra a la MISMA lista de leads que el catálogo corporativo
 * (HU-14), diferenciada por `source: 'newsletter'` — así hay una sola lista
 * exportable y no dos capturas de email desconectadas.
 */
const newsletterService = {
  /**
   * Suscribe un email al newsletter (endpoint público, sin token).
   *
   * @param email - Email del suscriptor
   * @returns Promise con la respuesta del servidor
   */
  subscribe: async (
    email: string
  ): Promise<{ success: boolean; message: string }> => {
    if (!email || email.trim() === '') {
      throw new Error('El email es requerido');
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      throw new Error('El formato del email no es válido');
    }

    try {
      await api.post('/leads', { email, source: 'newsletter' });

      return {
        success: true,
        message: '¡Gracias por suscribirte a nuestro newsletter!',
      };
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const serverError = (error.response?.data as { error?: string } | undefined)
          ?.error;
        throw new Error(serverError || 'Error al suscribirse al newsletter');
      }

      if (error instanceof Error) {
        throw error;
      }

      throw new Error('Error de conexión. Por favor verifica tu internet.');
    }
  },
};

export default newsletterService;
